import script from "./EditSalesListsView.vue?vue&type=script&setup=true&lang=js"
export * from "./EditSalesListsView.vue?vue&type=script&setup=true&lang=js"

import "./EditSalesListsView.vue?vue&type=style&index=0&id=644eb2ea&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-644eb2ea"]])

export default __exports__